import { getEndpoint, getHeaders } from "../../helpers/endpoint";
import {receiveEntities } from "../entities";
import { normalize } from "normalizr";
import { alertSchema } from "../../schemas/alert";
import swal from "sweetalert2";

export const CREATE_ALERT_IN_APP = 'CREATE_ALERT_IN_APP';
export const CREATE_ALERT_IN_APP_SUCCESS = 'CREATE_ALERT_IN_APP_SUCCESS';
export const CREATE_ALERT_IN_APP_ERROR = 'CREATE_ALERT_IN_APP_ERROR';

export const createAlertInApp = (payload, onSuccess) => {
    return (dispatch, getState) => {
        dispatch({ type: CREATE_ALERT_IN_APP, payload });
        delete payload.id;
        delete payload.updatedAt;
        delete payload.createdAt;

        fetch(getEndpoint('createAlertInApp'), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload)
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: CREATE_ALERT_IN_APP_ERROR,
                error: data.error,
            });
            else dispatch(successCreateAlertInApp(data, onSuccess));
        })
            .catch((error, type = CREATE_ALERT_IN_APP_ERROR) => { dispatch({ type, error }); });
    };
};

function successCreateAlertInApp(response, onSuccess) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: CREATE_ALERT_IN_APP_SUCCESS,
            receivedAt: Date.now(),
            response: response,
        });
    };
}

export const GET_ALL_ALERT_MPG = 'GET_ALL_ALERT_MPG';
export const GET_ALL_ALERT_MPG_SUCCESS = 'GET_ALL_ALERT_MPG_SUCCESS';
export const GET_ALL_ALERT_MPG_ERROR = 'GET_ALL_ALERT_MPG_ERROR';

export const getAllAlert = (onSuccess) => {
    return (dispatch, getState) => {
        dispatch({ type: GET_ALL_ALERT_MPG });

        fetch(getEndpoint('getAllAlerts'), {
            method: 'GET',
            headers: getHeaders(getState().authentication)
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: GET_ALL_ALERT_MPG_ERROR,
                error: data.error,
            });
            else dispatch(successGetAllAlert(data, onSuccess));
        })
            .catch((error, type = GET_ALL_ALERT_MPG_ERROR) => { dispatch({ type, error }); });
    };
};

function successGetAllAlert(response, onSuccess) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: GET_ALL_ALERT_MPG_SUCCESS,
            receivedAt: Date.now(),
            response: response.alerts,
        });
    };
}

export const GET_STAT_ALERT = 'GET_STAT_ALERT';
export const GET_STAT_ALERT_SUCCESS = 'GET_STAT_ALERT_SUCCESS';
export const GET_STAT_ALERT_ERROR = 'GET_STAT_ALERT_ERROR';

export const getStatAlert = (payload, onSuccess) => {
    return (dispatch, getState) => {
        dispatch({ type: GET_STAT_ALERT, payload });

        fetch(getEndpoint('getAlertStats'), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload)
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: GET_STAT_ALERT_ERROR,
                error: data.error,
            });
            else dispatch(successGetStatAlert(data, onSuccess));
        })
            .catch((error, type = GET_STAT_ALERT_ERROR) => { dispatch({ type, error }); });
    };
};

function successGetStatAlert(response, onSuccess) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: GET_STAT_ALERT_SUCCESS,
            receivedAt: Date.now(),
            response: response,
        });
    };
}

export const DELETE_ALERT_MPG = 'DELETE_ALERT_MPG';
export const DELETE_ALERT_MPG_SUCCESS = 'DELETE_ALERT_MPG_SUCCESS';
export const DELETE_ALERT_MPG_ERROR = 'DELETE_ALERT_MPG_ERROR';

export const deleteAlert = (alertId, onSuccess) => {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_ALERT_MPG,  });

        fetch(getEndpoint('deleteAlert', alertId), {
            method: 'DELETE',
            headers: getHeaders(getState().authentication)
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: DELETE_ALERT_MPG_ERROR,
                error: data.error,

            });
            else dispatch(successDeleteAlert(data, onSuccess));
        })
            .catch((error, type = DELETE_ALERT_MPG_ERROR) => { dispatch({ type, error,  }); });
    };
};

function successDeleteAlert(response, onSuccess) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: DELETE_ALERT_MPG_SUCCESS,
            receivedAt: Date.now(),
            lastResponse: response,
        });
    };
}

export const GET_ALERT_MPG = 'GET_ALERT_MPG';
export const GET_ALERT_MPG_SUCCESS = 'GET_ALERT_MPG_SUCCESS';
export const GET_ALERT_MPG_ERROR = 'GET_ALERT_MPG_ERROR';

export const getAlert = (alertId, onSuccess) => {
    return (dispatch, getState) => {
        dispatch({ type: GET_ALERT_MPG });

        fetch(getEndpoint('getAlert', alertId), {
            method: 'GET',
            headers: getHeaders(getState().authentication)
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: GET_ALERT_MPG_ERROR,
                error: data.error,
            });
            else dispatch(successGetAlert(data, onSuccess));
        })
            .catch((error, type = GET_ALERT_MPG_ERROR) => { dispatch({ type, error }); });
    };
};

function successGetAlert(response, onSuccess) {
    if(onSuccess) onSuccess(response);
    return dispatch => {
        const normalized = normalize(response, alertSchema);

        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: GET_ALERT_MPG_SUCCESS,
            receivedAt: Date.now(),
            id: normalized.result,
            lastResponse: response,
        });
    };
}

export const REQUEST_UPDATE_ALERT = 'REQUEST_UPDATE_ALERT';
export const SUCCESS_UPDATE_ALERT = 'SUCCESS_UPDATE_ALERT';
export const FAIL_UPDATE_ALERT = 'FAIL_UPDATE_ALERT';

export const updateAlert = (alertId, payload, onSuccess, onError) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_UPDATE_ALERT, payload });
        delete payload.id;
        delete payload.updatedAt;
        delete payload.createdAt;

        return fetch(getEndpoint('updateAlert', alertId), {
            method: 'PUT',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
                if(data.error) {
                    if (onError) onError(data.error);
                    dispatch({
                        type: FAIL_UPDATE_ALERT,
                        error: data.error,
                    });
                }
                else dispatch(successUpdateAlert(data, onSuccess, payload));
            })
            .catch((error, type = FAIL_UPDATE_ALERT) => {
                if (onError) onError(error);
                dispatch({ type, error });
            });
    };
};

function successUpdateAlert(response, onSuccess, payload) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: SUCCESS_UPDATE_ALERT,
            response,
            payload,
        });
    };
}

export const REQUEST_VALIDATE_ALERT_IN_APP = 'REQUEST_VALIDATE_ALERT_IN_APP';
export const SUCCESS_VALIDATE_ALERT_IN_APP = 'SUCCESS_VALIDATE_ALERT_IN_APP';
export const FAIL_VALIDATE_ALERT_IN_APP = 'FAIL_VALIDATE_ALERT_IN_APP';

export const validateAlertInApp = (alertId, onSuccess, onError) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_VALIDATE_ALERT_IN_APP });

        return fetch(getEndpoint('validateAlertInApp', alertId), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
                if(data.error) {
                    if (onError) onError(data.error);
                    dispatch({
                        type: FAIL_VALIDATE_ALERT_IN_APP,
                        error: data.error,
                    });
                }
                else dispatch(successValidateAlertInApp(data, onSuccess));
            })
            .catch((error, type = FAIL_VALIDATE_ALERT_IN_APP) => {
                if (onError) onError(error);
                dispatch({ type, error });
            });
    };
};

function successValidateAlertInApp(response, onSuccess) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: SUCCESS_VALIDATE_ALERT_IN_APP,
            response,
        });
    };
}

export const sendAlertUsersTest = (alertId, payload, onSuccess, onError) => {
    return (dispatch, getState) => {
        return fetch(getEndpoint('sendAlertUsersTest', alertId), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
                if (data.error) {
                    swal({
                        title: `Oops...`,
                        type: 'error',
                        html: `Something went wrong !<br/>${data.error}<br/>`,
                    });
                    if (onError) onError(data.error);
                }
                else if (onSuccess) {
                    onSuccess(data);
                }
            })
            .catch((error) => {
                swal({
                    title: `Oops...`,
                    type: 'error',
                    html: `Something went wrong !<br/>${error}<br/>`,
                });
                if (onError) onError(error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/entities/alertMPG.js